import React from 'react';
import { orderAvailability } from '../utils/orderAvailability';
import ProductAvailabilityNote from './ProductAvailabilityNote';
import PreOrderBlock from './PreOrderBlock';

const OrderAvailabilityBadges = ({ product }) => {
  const { ordered, toOrder } = orderAvailability(product);
  if (ordered === 0 && toOrder === 0) return null;
  return <div aria-label="Наявність товару">
    {ordered > 0 && <PreOrderBlock expectedArrivalDate={product.expectedArrivalDate} className='mt-1' />}
    {toOrder > 0 && <ProductAvailabilityNote kind='on-demand' quantity={toOrder} productId={product.id} />}
  </div>;
};

export default OrderAvailabilityBadges;
